export default __webpack_public_path__ + "static/media/PlusCircle.e09c7ac1.svg";